import * as Yup from 'yup';

import { SearchableSelectType } from 'components/inputs/searchableSelect';

export enum SubmitType {
    save = 'save',
    saveAndAdd = 'saveAndAdd',
}
export interface TopicManagementCreateFormikValues {
    name: string;
    description?: string;
    formulas?: SearchableSelectType[];
    contactEvents?: SearchableSelectType[];
    surfaceFormulas?: Record<string, number[]>;
    submitType?: SubmitType;
}

export const validationSchema = Yup.object({
    name: Yup.string().trim().required('Name is required'),
});

export enum TopicTabs {
    MessageGroups = 'messageGroups',
    SurfaceMessageGroups = 'surfaceMessageGroups',
    Events = 'events',
    Labels = 'labels',
}

export const TopicTabsData: Record<TopicTabs, string> = {
    [TopicTabs.MessageGroups]: 'Message Groups',
    [TopicTabs.SurfaceMessageGroups]: 'Surface Message Groups',
    [TopicTabs.Events]: 'Events',
    [TopicTabs.Labels]: 'Labels',
};
